export const menuItems = [
  { title: "Hem", link: "/" },
  { title: "Behandlingar", link: "/behandlingar" },
  { title: "Om oss", link: "/om-oss" },
  { title: "Kontakt", link: "/kontakt" },
  { title: "Blogg", link: "/blogg" },
];
